var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadcrumbList),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.path}}},[_vm._v(" "+_vm._s(_vm.$lang(item,'title')))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }